import { z } from "zod";

import { validationPasswordErrorMessages } from "../i18n/validation-error-codes.ts";

type PasswordRule = {
  id: string;
  params?: Record<string, any>;
  test: (value: string) => boolean;
};

export const passwordRules: PasswordRule[] = [
  {
    id: validationPasswordErrorMessages.minMax.id,
    params: { max: 72, min: 12 },
    test: (v) => v.length >= 12 && v.length <= 72,
  },
  {
    id: validationPasswordErrorMessages.oneLetterInLow.id,
    test: (v) => /[a-z]/.test(v),
  },
  {
    id: validationPasswordErrorMessages.oneLetterInTop.id,
    test: (v) => /[A-Z]/.test(v),
  },
  {
    id: validationPasswordErrorMessages.oneDigit.id,
    test: (v) => /\d/.test(v),
  },
  {
    id: validationPasswordErrorMessages.oneSpecialSymbol.id,
    test: (v) =>
      /^[A-Za-z0-9!@#$%^&*()\-_.+]+$/.test(v) && /[!@#$%^&*()\-_.+]/.test(v),
  },
];

export const passwordSchema = z.string().superRefine((value, ctx) => {
  for (const rule of passwordRules) {
    if (!rule.test(value)) {
      ctx.addIssue({
        code: "custom",
        message: rule.id,
        params: rule.params,
      });
    }
  }
});

export const getPasswordValidationState = (value: string) => {
  return passwordRules.map((rule) => ({
    id: rule.id,
    params: rule.params,
    isValid: rule.test(value),
  }));
};
